import './Initiatives.css';

const initiatives = [
  {
    no: 1,
    area: 'Idol Height',
    areaHi: 'प्रतिमा की ऊँचाई',
    activity: 'Reduce idol height by 2–3 feet compared to the previous year.',
    activityHi: 'पिछले वर्ष की तुलना में प्रतिमा की ऊँचाई 2–3 फीट कम रखी जाए।',
    benefit: 'Reduced consumption of materials and natural resources; lower environmental impact.',
    benefitHi: 'सामग्री एवं प्राकृतिक संसाधनों की बचत होगी तथा पर्यावरण पर प्रतिकूल प्रभाव कम होगा।',
  },
  {
    no: 2,
    area: 'Idol Material',
    areaHi: 'प्रतिमा की सामग्री',
    activity: 'Use eco-friendly clay idols instead of Plaster of Paris (POP) idols.',
    activityHi: 'प्लास्टर ऑफ पेरिस (POP) के स्थान पर प्राकृतिक मिट्टी से बनी पर्यावरण-अनुकूल प्रतिमा का उपयोग किया जाए।',
    benefit: 'Reduction in water pollution and environmental damage.',
    benefitHi: 'जल प्रदूषण में कमी आएगी तथा पर्यावरण का संरक्षण होगा।',
  },
  {
    no: 3,
    area: 'Visarjan Practices',
    areaHi: 'विसर्जन व्यवस्था',
    activity: 'Promote immersion in artificial ponds or designated eco-friendly facilities instead of rivers and natural water bodies.',
    activityHi: 'नदियों एवं प्राकृतिक जलाशयों के स्थान पर कृत्रिम विसर्जन कुंडों का उपयोग किया जाए।',
    benefit: 'Reduced water pollution and protection of aquatic ecosystems.',
    benefitHi: 'जल प्रदूषण कम होगा तथा जलीय जीवन एवं पर्यावरण की सुरक्षा होगी।',
  },
  {
    no: 4,
    area: 'Noise Pollution',
    areaHi: 'ध्वनि प्रदूषण',
    activity: 'Maintain sound levels within prescribed limits and reduce excessive DJ volume (around 85 dB) during Aagman and Visarjan processions.',
    activityHi: 'आगमन एवं विसर्जन के दौरान ध्वनि स्तर निर्धारित सीमा में रखा जाए तथा अत्यधिक तेज़ डीजे का उपयोग न किया जाए।',
    benefit: 'Reduced noise pollution and improved public health.',
    benefitHi: 'ध्वनि प्रदूषण कम होगा तथा जनस्वास्थ्य बेहतर होगा।',
  },
  {
    no: 5,
    area: 'Cultural Preservation',
    areaHi: 'सांस्कृतिक संरक्षण',
    activity: 'Encourage the use of traditional Dhol, Nagara, and cultural instruments instead of high-volume DJs.',
    activityHi: 'तेज़ डीजे के स्थान पर पारंपरिक ढोल, नगाड़ा एवं अन्य सांस्कृतिक वाद्ययंत्रों को प्रोत्साहित किया जाए।',
    benefit: 'Promotion of cultural heritage and reduction in noise pollution.',
    benefitHi: 'सांस्कृतिक विरासत का संरक्षण होगा तथा ध्वनि प्रदूषण कम होगा।',
  },
  {
    no: 6,
    area: 'Air Pollution',
    areaHi: 'वायु प्रदूषण',
    activity: 'Minimize the use of fuel-powered vehicles and encourage manual chariots (Rath Yatra) or community-led processions.',
    activityHi: 'ईंधन चालित वाहनों का उपयोग कम कर हाथ से खींचे जाने वाले रथ अथवा सामुदायिक शोभायात्रा को बढ़ावा दिया जाए।',
    benefit: 'Reduced fuel consumption and air pollution.',
    benefitHi: 'ईंधन की बचत होगी तथा वायु प्रदूषण कम होगा।',
  },
  {
    no: 7,
    area: 'Environment Protection',
    areaHi: 'पर्यावरण संरक्षण',
    activity: 'Organize tree plantation drives during the festival period.',
    activityHi: 'गणेशोत्सव के दौरान वृक्षारोपण अभियान आयोजित किए जाएँ।',
    benefit: 'Increased green cover and environmental conservation.',
    benefitHi: 'हरित क्षेत्र बढ़ेगा तथा पर्यावरण संरक्षण को बढ़ावा मिलेगा।',
  },
  {
    no: 8,
    area: 'Zero Plastic Festival',
    areaHi: 'प्लास्टिक मुक्त गणेशोत्सव',
    activity:
      'Create awareness about reducing single-use plastic during the festival. Encourage Mandal members and their families to use reusable cloth bags. Prepare and distribute cloth bags to Mandal members, nearby residents, and the public to promote eco-friendly shopping habits.',
    activityHi:
      'गणेशोत्सव के दौरान सिंगल-यूज़ प्लास्टिक का पूर्णत: त्याग करने के लिए जनजागरूकता फैलाई जाए। मंडल के सदस्यों एवं उनके परिवारों को कपड़े के थैले (Cloth Bags) उपयोग करने के लिए प्रेरित करें। मंडल द्वारा कपड़े के थैले तैयार कर सदस्यों, आसपास के नागरिकों एवं आम जनता में वितरित करें।',
    benefit: 'Reduce plastic pollution and encourage sustainable alternatives.',
    benefitHi: 'प्लास्टिक प्रदूषण को कम करना एवं पर्यावरण-अनुकूल विकल्पों को बढ़ावा देना।',
  },
  {
    no: 9,
    area: 'Water Conservation',
    areaHi: 'जल संरक्षण अभियान',
    activity:
      'Conduct a "Water Saving Drive" by checking taps in the homes of Mandal members, families, and friends for leakages. Repair or replace old or faulty taps to prevent water loss. Encourage households to collect RO purifier wastewater and reuse it for cleaning, mopping, gardening, or other non-drinking purposes. Promote the installation of simple rainwater harvesting systems or recharge pits in homes, schools, temples, and community buildings to conserve rainwater and recharge groundwater.',
    activityHi:
      '"जल बचाओ अभियान" के अंतर्गत मंडल के सदस्यों, उनके परिवारों एवं मित्रों के घरों में पानी की नलों की जाँच कर रिसाव (Leakage) होने पर उनकी मरम्मत या आवश्यकता अनुसार नए नल लगाने के लिए प्रेरित करें। RO वाटर प्यूरीफायर से निकलने वाले अपशिष्ट जल को एकत्रित कर सफाई, पोंछा, बागवानी तथा अन्य गैर-पीने योग्य कार्यों में पुनः उपयोग करने के लिए प्रोत्साहित करें। साथ ही, घरों, विद्यालयों, मंदिरों एवं सामुदायिक भवनों में वर्षा जल संचयन (Rainwater Harvesting) प्रणाली अथवा रिचार्ज पिट (Recharge Pit) स्थापित करने के लिए जागरूकता फैलाएँ और लोगों को इसके लिए प्रेरित करें।',
    benefit: 'Reduce water wastage and promote responsible water conservation practices.',
    benefitHi: 'जल की बर्बादी रोकना एवं जल संरक्षण की आदतों को बढ़ावा देना।',
  },
  {
    no: 10,
    area: 'Cleanliness & Waste Management',
    areaHi: 'स्वच्छता एवं कचरा प्रबंधन',
    activity: 'Organize community clean-up drives for streets, rivers, parks, and public places.',
    activityHi: 'सड़कों, नदियों, उद्यानों एवं सार्वजनिक स्थानों पर स्वच्छता अभियान चलाया जाए।',
    benefit: 'Promotes civic responsibility and environmental protection.',
    benefitHi: 'स्वच्छता के प्रति जन-जागरूकता बढ़ेगी तथा पर्यावरण संरक्षण को बल मिलेगा।',
  },
  {
    no: 11,
    area: 'Digital Awareness',
    areaHi: 'डिजिटल जागरूकता',
    activity:
      'Conduct awareness sessions on Artificial Intelligence (AI), digital literacy, cyber security, online fraud prevention, safe internet practices, and emerging technologies. Educate citizens about identifying fraudulent calls, phishing, hacking, OTP scams, and digital payment safety.',
    activityHi:
      'कृत्रिम बुद्धिमत्ता (AI), डिजिटल साक्षरता, साइबर सुरक्षा, ऑनलाइन धोखाधड़ी से बचाव, सुरक्षित इंटरनेट उपयोग एवं आधुनिक तकनीकों पर जागरूकता कार्यक्रम आयोजित किए जाएँ। नागरिकों को फर्जी कॉल, फिशिंग, हैकिंग, OTP धोखाधड़ी एवं सुरक्षित डिजिटल भुगतान के बारे में जानकारी दी जाए।',
    benefit: 'Improved digital literacy, enhanced cyber safety awareness, and increased confidence in using digital technologies responsibly.',
    benefitHi: 'नागरिकों में डिजिटल साक्षरता एवं साइबर सुरक्षा के प्रति जागरूकता बढ़ेगी तथा वे डिजिटल तकनीकों का सुरक्षित एवं जिम्मेदारीपूर्वक उपयोग कर सकेंगे।',
  },
  {
    no: 12,
    area: 'Mental Health',
    areaHi: 'मानसिक स्वास्थ्य',
    activity: 'Organize awareness programs on mental health, stress management, and suicide prevention.',
    activityHi: 'मानसिक स्वास्थ्य, तनाव प्रबंधन एवं आत्महत्या रोकथाम पर जागरूकता कार्यक्रम आयोजित किए जाएँ।',
    benefit: 'Stronger community well-being and resilience.',
    benefitHi: 'समाज में मानसिक स्वास्थ्य के प्रति जागरूकता एवं सहयोग बढ़ेगा।',
  },
  {
    no: 13,
    area: 'Community Welfare Fund',
    areaHi: 'सामुदायिक सहायता कोष',
    activity:
      'Create and maintain an Emergency Relief Fund through voluntary contributions. Encourage every Ganesh Mandal to reserve at least 10% of the funds collected during Ganesh Mahotsav to provide financial assistance during emergencies such as floods, medical emergencies, accidents, or other unforeseen situations affecting Mandal members and their families.',
    activityHi:
      'स्वैच्छिक योगदान से आपातकालीन सहायता कोष बनाया एवं संचालित किया जाए। प्रत्येक गणेश मंडल को प्रोत्साहित किया जाए कि गणेश महोत्सव के दौरान एकत्रित निधि का कम से कम 10% सुरक्षित रखें, ताकि बाढ़, चिकित्सा आपातकाल, दुर्घटना अथवा अन्य आकस्मिक परिस्थितियों में मंडल के सदस्यों एवं उनके परिवारों को आर्थिक सहायता प्रदान की जा सके।',
    benefit: 'Strengthens financial preparedness, promotes mutual support, and ensures timely assistance during emergencies.',
    benefitHi: 'आर्थिक सुरक्षा को मजबूत करेगा, पारस्परिक सहयोग की भावना को बढ़ावा देगा तथा आपातकालीन परिस्थितियों में समय पर सहायता सुनिश्चित करेगा।',
  },
  {
    no: 14,
    area: 'Gau Seva',
    areaHi: 'गौ सेवा',
    activity:
      'Support Gaushalas by donating fodder, medicines, and other essential supplies. Construct or repair shaded shelters to protect cattle from extreme heat and heavy rainfall.',
    activityHi:
      'गौशालाओं को चारा, दवाइयाँ एवं अन्य आवश्यक सामग्री उपलब्ध कराई जाए। अत्यधिक गर्मी एवं वर्षा से पशुओं की सुरक्षा हेतु छायादार शेड का निर्माण या मरम्मत की जाए।',
    benefit: 'Improved welfare and protection of cattle while promoting compassion, community service, and Gau Seva.',
    benefitHi: 'गौशालाओं के संरक्षण एवं कल्याण को बढ़ावा मिलेगा तथा समाज में सेवा, करुणा और गौ सेवा की भावना सुदृढ़ होगी।',
  },
  {
    no: 15,
    area: 'Sustainable Living',
    areaHi: 'सतत जीवनशैली',
    activity: 'Encourage members to use bicycles at least once a week and adopt eco-friendly transportation.',
    activityHi: 'सदस्यों को सप्ताह में कम से कम एक दिन साइकिल चलाने एवं पर्यावरण-अनुकूल परिवहन अपनाने के लिए प्रेरित किया जाए।',
    benefit: 'Reduced carbon emissions and healthier lifestyles.',
    benefitHi: 'कार्बन उत्सर्जन कम होगा तथा स्वस्थ जीवनशैली को बढ़ावा मिलेगा।',
  },
  {
    no: 16,
    area: 'Educational Support',
    areaHi: 'शैक्षणिक सहयोग',
    activity: 'Renovate, clean, paint, and improve infrastructure in Anganwadis and Government Schools.',
    activityHi: 'आंगनवाड़ी एवं सरकारी विद्यालयों की सफाई, रंगाई-पुताई, मरम्मत एवं आवश्यक सुविधाओं में सहयोग किया जाए।',
    benefit: 'Better learning environment for children.',
    benefitHi: 'बच्चों के लिए बेहतर शिक्षण वातावरण उपलब्ध होगा।',
  },
  {
    no: 17,
    area: 'Student Assistance',
    areaHi: 'विद्यार्थी सहायता',
    activity: 'Provide educational materials, scholarships, or financial support to economically weaker students.',
    activityHi: 'आर्थिक रूप से कमजोर विद्यार्थियों को शैक्षिक सामग्री, छात्रवृत्ति अथवा आर्थिक सहायता प्रदान की जाए।',
    benefit: 'Better educational opportunities for deserving students.',
    benefitHi: 'योग्य एवं ज़रूरतमंद विद्यार्थियों को बेहतर शिक्षा के अवसर प्राप्त होंगे।',
  },
  {
    no: 18,
    area: 'Blood Donation',
    areaHi: 'रक्तदान',
    activity: 'Organize voluntary blood donation camps.',
    activityHi: 'स्वैच्छिक रक्तदान शिविर आयोजित किए जाएँ।',
    benefit: 'Saves lives and promotes social responsibility.',
    benefitHi: 'अनेक लोगों का जीवन बचाने में सहायता मिलेगी तथा सामाजिक उत्तरदायित्व की भावना बढ़ेगी।',
  },
  {
    no: 19,
    area: 'Health Check-up Camp',
    areaHi: 'स्वास्थ्य जाँच शिविर',
    activity: 'Conduct free medical, eye, dental check-ups, and health awareness camps.',
    activityHi: 'नि:शुल्क स्वास्थ्य परीक्षण, नेत्र एवं दंत चिकित्सा शिविर तथा स्वास्थ्य जागरूकता कार्यक्रम आयोजित किए जाएँ।',
    benefit: 'Particularly beneficial for economically weaker sections.',
    benefitHi: 'विशेष रूप से आर्थिक रूप से कमज़ोर वर्गों को इसका लाभ मिलेगा।',
  },
  {
    no: 20,
    area: 'Food Distribution Programs',
    areaHi: 'अन्नदान एवं राशन वितरण',
    activity: 'Distribute meals and ration kits to underprivileged families, homeless persons, and disaster-affected communities.',
    activityHi: 'ज़रूरतमंद परिवारों, बेघर व्यक्तियों एवं आपदा प्रभावित लोगों को भोजन एवं राशन किट वितरित किए जाएँ।',
    benefit: 'Provides essential support to needy people.',
    benefitHi: 'आवश्यक सहायता प्राप्त होगी।',
  },
];

const supportingPoints = [
  {
    title: 'Global sea level rise',
    text:
      'Since 1880, global sea levels have risen by 8–9 inches (21–24 cm). According to the Intergovernmental Panel on Climate Change (IPCC), levels are projected to rise by 30–100 cm by 2100 — a direct risk to approximately 200 coastal nations and regions, including India.',
  },
  {
    title: 'Extreme climate impacts',
    text:
      'Climate change is not just about a 2°C increase — it manifests in extreme weather events. States like Uttar Pradesh, Bihar, Rajasthan, and Haryana have already experienced temperatures close to 50°C this summer, making normal human life unsustainable and endangering future generations.',
  },
  {
    title: 'Impact on labour productivity',
    text:
      'Rising temperatures severely reduce the efficiency of daily wage labourers (majdoor/dihadi). Sustained exposure to extreme heat makes it nearly impossible for them to perform well, directly affecting economic productivity and social stability.',
  },
];

const climateSections = [
  {
    title: 'Rising Temperatures & Heatwaves',
    text:
      "India's average temperature has increased by approximately 0.7–0.9°C between 1901 and 2024, with the hottest days warming by 1.5–2°C in some regions.",
  },
  {
    title: 'Extreme Weather Events',
    text:
      'India has experienced an increase in floods, droughts, cyclones, and irregular monsoon patterns. A majority of Indians have personally experienced severe heat waves (71%), agricultural pests and diseases (60%), droughts and water shortages (52%), and severe air pollution (52%) in the past year.',
  },
  {
    title: 'Water Resources & Glacial Retreat',
    text:
      'Rising temperatures on the Tibetan Plateau are causing Himalayan glaciers to retreat, threatening the flow of major rivers such as the Ganges, Brahmaputra, Yamuna, and Indus — increasing the risk of droughts and water scarcity, with projections indicating a marked increase in drought frequency by the end of the century.',
  },
  {
    title: 'Agriculture & Food Security',
    text:
      'Climate change poses a significant threat to food security, impacting crop yields, fisheries, and livestock. Irregular monsoons, heat stress, and increased pest outbreaks reduce agricultural productivity, potentially leading to famines and food shortages, with millions at risk of falling back into poverty.',
  },
  {
    title: 'Health & Air Pollution',
    text:
      'Extreme heat, water scarcity, and air pollution exacerbate health risks. India has some of the world\'s most polluted cities, with air pollution contributing to over 1.2 million deaths in 2017. Children and women are particularly vulnerable to climate-related malnutrition, heat stress, and waterborne diseases.',
  },
  {
    title: 'Social & Economic Inequalities',
    text:
      'Climate change disproportionately affects marginalised groups, including lower caste communities, indigenous Adivasis, and the urban poor — who face higher exposure to floods, heatwaves, and pollution while having limited resources to adapt.',
  },
  {
    title: 'Coastal & Marine Impacts',
    text:
      "Rising sea levels and warming of the tropical Indian Ocean are increasing marine heatwaves, projected to occur nearly 200 days per year by 2050, threatening fisheries, coastal ecosystems, and livelihoods. Coastal erosion and flooding also pose displacement risks for millions living along India's coastline.",
  },
];

export default function Initiatives() {
  return (
    <div className="initiatives-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Community Guidelines</div>
          <h1>Green & Social Initiatives</h1>
          <p>
            20 suggested activities every Mandal can adopt to make Sarvajanik Ganesh Mahotsav more eco-friendly and
            socially impactful — for a cleaner environment and a stronger community.
          </p>
        </div>
      </div>

      <section className="initiatives-section">
        <div className="container initiatives-card">
          <p className="initiatives-intro">
            Every Sarvajanik Ganesh Mahotsav Mandal has an opportunity to lead by example. The table below lists
            suggested activities across environmental and social areas of concern, along with the benefit each one
            brings to our community and environment.
          </p>

          <div className="initiatives-list">
            {initiatives.map((item) => (
              <div className="initiative-card" key={item.no}>
                <div className="initiative-card-header">
                  <span className="initiative-no">{item.no}</span>
                  <div>
                    <h3>{item.area}</h3>
                    <p className="initiative-area-hi">{item.areaHi}</p>
                  </div>
                </div>
                <div className="initiative-card-body">
                  <div className="initiative-field">
                    <span className="initiative-field-label">Suggested Activity / प्रस्तावित गतिविधि</span>
                    <p>{item.activity}</p>
                    <p className="initiative-hi">{item.activityHi}</p>
                  </div>
                  <div className="initiative-field">
                    <span className="initiative-field-label">Expected Benefit / अपेक्षित लाभ</span>
                    <p>{item.benefit}</p>
                    <p className="initiative-hi">{item.benefitHi}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="climate-section">
        <div className="container">
          <div className="section-header">
            <div className="badge">Why This Matters</div>
            <h2>Climate Change in India</h2>
            <div className="divider">
              <div className="divider-line" />
              <span className="divider-icon">🌸</span>
              <div className="divider-line right" />
            </div>
            <p>
              Climate change in India has led to rising temperatures, more frequent extreme weather events, glacier
              retreat, and significant socio-economic and health challenges — the very reasons every Mandal's small,
              collective effort matters.
            </p>
          </div>

          <div className="climate-grid">
            {climateSections.map((c) => (
              <div className="climate-card card" key={c.title}>
                <h3>{c.title}</h3>
                <p>{c.text}</p>
              </div>
            ))}
          </div>

          <div className="supporting-points">
            <h3>Additional Points Supporting the Project</h3>
            <ul>
              {supportingPoints.map((p) => (
                <li key={p.title}>
                  <strong>{p.title}:</strong> {p.text}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
